import script from "./tree.vue?vue&type=script&setup=true&lang=js"
export * from "./tree.vue?vue&type=script&setup=true&lang=js"

import "./tree.vue?vue&type=style&index=0&id=0c0737ba&scoped=true&lang=css"
import "./tree.vue?vue&type=style&index=1&id=0c0737ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c0737ba"]])

export default __exports__